import { BrowserAuthError, IPublicClientApplication, InteractionRequiredAuthError } from "@azure/msal-browser";

export const getMSToken = async (instance: IPublicClientApplication) => {
  const activeAccount = instance.getAllAccounts()[0];

  const accessTokenRequest = {
    scopes: ["user.read"],
    account: activeAccount,
  };

  try {
    return await instance.acquireTokenSilent(accessTokenRequest);
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError || error instanceof BrowserAuthError) {
      return instance.acquireTokenRedirect(accessTokenRequest);
    }
  }
};

export const userLogout = async (instance: IPublicClientApplication) => {
  instance.logoutRedirect();
};
